import { api_create_veriff_session_path, api_fetch_veriff_decision_path } from '@routes';

import request from './request';

export const VERIFF_SESSION_KEY = 'veriffSession';

export interface VeriffSessionParams {
  first_name: string;
  last_name: string;
  user_id: string;
}

export interface VeriffDecisionParams {
  session_id: string;
  user_id: number;
}

export interface VeriffSessionResponse {
  sessionId: string;
  sessionUrl: string;
}

export interface VeriffDecisionResponse {
  dobVerified?: boolean;
  isYPEligible?: boolean;
  message?: string;
  success: boolean;
}

export const createVeriffSession = async (
  params: VeriffSessionParams
): Promise<VeriffSessionResponse> => {
  const response = await request('post', api_create_veriff_session_path(), params);
  return response;
};

export const fetchVeriffDecision = async (
  params: VeriffDecisionParams
): Promise<VeriffDecisionResponse> => {
  const response = await request('get', api_fetch_veriff_decision_path(params));
  return response;
};
